// Live app — no example content. Real listings appear as users create them.
// Subscription tiers below map to real Stripe prices created by
// backend/setup_stripe.py — do not remove.

export const VEHICLES = [];
export const RIDES = [];
export const EVENTS = [];
export const PLAYLIST = [];

export const TIERS = [
  {
    id: 'free', name: 'Free', price: 0, cadence: 'forever', tagline: 'Get rolling.',
    features: ['Browse marketplace', 'Join up to 3 rides / month', 'Attend public events', 'PWA install', 'PIPEDA privacy shield'],
    cta: 'Start free', highlight: false,
    lookup_keys: null,
  },
  {
    id: 'pro', name: 'Pro', price: 9.99, cadence: '/mo', tagline: 'For daily drivers.',
    features: ['Unlimited ride requests', 'List 3 vehicles', '5% lower commission', 'Priority ride matching', 'Advanced filters'],
    cta: 'Go Pro', highlight: false,
    lookup_keys: { monthly: 'pro_monthly', annual: 'pro_yearly' },
  },
  {
    id: 'enthusiast', name: 'Enthusiast', price: 19.99, cadence: '/mo', tagline: 'Built for the culture.',
    features: ['Everything in Pro', 'List up to 10 vehicles', 'Host private events', 'Exclusive meets access', 'Custom garage page', 'Analytics dashboard'],
    cta: 'Join Enthusiasts', highlight: true,
    lookup_keys: { monthly: 'enthusiast_monthly', annual: 'enthusiast_yearly' },
  },
  {
    id: 'dealer', name: 'Dealer', price: 49.99, cadence: '/mo', tagline: 'For pro sellers.',
    features: ['Everything in Enthusiast', 'Unlimited listings', 'Verified dealer badge', 'Bulk import CSV', 'Lead CRM & inbox', 'Fleet analytics', 'API access'],
    cta: 'Become a Dealer', highlight: false,
    lookup_keys: { monthly: 'dealer_monthly', annual: 'dealer_yearly' },
  },
];
